var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 30,
    viewBox: "0 0 43 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.48649 1.62162V3.24324H1.62162C0.726038 3.24324 0 3.96933 0 4.86486C0 5.7604 0.726038 6.48649 1.62162 6.48649H3.24324V30H38.9189V6.48649H40.5405C41.4361 6.48649 42.1622 5.7604 42.1622 4.86486C42.1622 3.96933 41.4361 3.24324 40.5405 3.24324H35.6757V1.62162C35.6757 0.726087 34.9496 0 34.0541 0H30.8108C29.9152 0 29.1892 0.726087 29.1892 1.62162V3.24324H12.973V1.62162C12.973 0.726087 12.2469 0 11.3514 0H8.10811C7.21252 0 6.48649 0.726087 6.48649 1.62162ZM26.5714 9.97836L23.1835 15.8464L28.2395 18.7658L16.8812 25.9444C16.1653 26.3965 15.3224 25.5869 15.7458 24.8533L19.1337 18.9852L14.0777 16.0662L25.436 8.88764C26.1519 8.43512 26.9948 9.24514 26.5714 9.97836Z",
    fill: "#C0BFC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectro);
export default __webpack_public_path__ + "static/media/Electro.82cd754695c9ab2aaa3229712afaab01.svg";
export { ForwardRef as ReactComponent };